import React from "react";
import styled from "styled-components";

import useDoubleClick from "../../hooks/useDoubleClick/useDoubleClick";
import { usePlayerStore } from "../../store/usePlayerStore";

import { stopEventPropagation } from "./helpers";

const OverlayArea = styled.div<{
  isMobile: boolean;
}>`
  height: auto;
  inset: 56px 0 ${({ isMobile }) => (isMobile ? 0 : 56)}px; /* top left/right bottom */
  position: absolute;

  &,
  &:focus {
    outline: none !important;
  }
`;

interface Props {
  onClick: () => unknown;
  onDoubleClick?: () => unknown;
}

export const OverlayControls = ({ onClick, onDoubleClick }: Props) => {
  const { useStoreState } = usePlayerStore();
  const device = useStoreState.device();
  return (
    <OverlayArea
      aria-hidden={true}
      isMobile={device.isMobile}
      onClick={useDoubleClick({
        doubleClickDelay: 300,
        onClick,
        onDoubleClick
      })}
      onFocus={stopEventPropagation}
      onFocusCapture={stopEventPropagation}
      tabIndex={-1}
    />
  );
};
